import { API_BASE_URL as baseUri } from "config/env";
import { AuthHeader } from "services/authHeader";
import { NotificationTypes } from "shared/interfaces/status-notifications-interfaces";
import { showNotification } from "shared/slices/statusNotificationsSlice";
import { createAppAsyncThunk } from "shared/state/createAppAsyncThunk";
import { rejectFailedResponse, rejectNetworkError } from "shared/state/rejectFailedRequest";
import { ApprovalSettingsDTO, GetApprovalSettingsResponse, UpdateApprovalSettingsResponse } from "./approvalSettingsDtos";

/** The settings of every request type, with the people they can be given to. Stored in the slice. */
export const GetApprovalSettings = createAppAsyncThunk<GetApprovalSettingsResponse, void>(
    "Slice/ApprovalSettingsSlice/GetApprovalSettings",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetch(baseUri + "api/approval-settings/get", { method: "GET", headers: AuthHeader() });
            if (response.status === 200) {
                const responseModel = await response.json() as GetApprovalSettingsResponse;
                return responseModel;
            }
            else {
                return rejectFailedResponse(response, { dispatch, rejectWithValue });
            }
        }
        catch {
            return rejectNetworkError({ dispatch, rejectWithValue });
        }
    }
);

/** Saves the settings of every request type at once, as the backend takes them. Not stored: the page reloads. */
export const UpdateApprovalSettings = createAppAsyncThunk<UpdateApprovalSettingsResponse, ApprovalSettingsDTO[]>(
    "Slice/ApprovalSettingsSlice/UpdateApprovalSettings",
    async (settings, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetch(baseUri + "api/approval-settings/update", {
                method: "PUT",
                headers: AuthHeader(),
                body: JSON.stringify(settings),
            });
            if (response.status === 200) {
                const responseModel = await response.json() as UpdateApprovalSettingsResponse;
                dispatch(showNotification({ message: "Approval settings has been successfully changed.", type: NotificationTypes.Success }));
                return responseModel;
            }
            else {
                return rejectFailedResponse(response, { dispatch, rejectWithValue });
            }
        }
        catch {
            return rejectNetworkError({ dispatch, rejectWithValue });
        }
    }
);
